import { LockKeyhole, LogOut, PackageSearch } from "lucide-react";
import { ADMIN_LOGIN_PATH, CUSTOMER_ORDERS_PATH } from "./accessNavigation";

type TopbarProps = {
  operatorMode: boolean;
  customerView?: boolean;
  onHome: () => void;
  onExit: () => void;
};

/** Shared compact application header used by storefront and operator views. */
export function Topbar({ operatorMode, customerView = false, onHome, onExit }: TopbarProps) {
  return (
    <header className="topbar">
      <button className="wordmark" type="button" aria-label="YooY 首页" onClick={onHome}>
        <img className="brand-logo" src="/yoyo-logo.svg" alt="" aria-hidden="true" />
        <span className="sr-only">YooY</span>
      </button>
      {operatorMode && !customerView ? (
        <button className="icon-button" type="button" aria-label="退出账户中心" onClick={onExit}>
          <LogOut size={16} />
        </button>
      ) : (
        <nav className="topbar-actions" aria-label="账户入口">
          <a className="customer-orders-link" href={CUSTOMER_ORDERS_PATH} aria-current={customerView ? "page" : undefined}>
            <PackageSearch size={16} aria-hidden="true" /><span>我的订单</span>
          </a>
          <a className="icon-button" href={ADMIN_LOGIN_PATH} aria-label="管理员登录" title="管理员登录">
            <LockKeyhole size={16} aria-hidden="true" />
          </a>
        </nav>
      )}
    </header>
  );
}
